import { Box, Grid2, TextField, Button } from '@mui/material'
import React from 'react'
import * as Yup from "yup"
export const BecomeSellerFormStep2 = ({formik}:any) => {
    
  return (
    <Box>
   
    <>
        <Grid2 container spacing={3}>
            <Grid2 size={{xs:12}}>
                <TextField
                fullWidth
                name="pickupAddress.streetName"
                label="Street Name"
                value={formik.values.pickupAddress?.streetName}
                onChange={formik.handleChange}
                error={formik.touched.pickupAddress?.streetName&& Boolean(formik.errors. pickupAddress?.streetName)}
                helperText={formik.touched.pickupAddress?.streetName && formik.errors. pickupAddress?.streetName}
                />
            </Grid2>
            <Grid2 size={{xs:6}}>
                <TextField
                fullWidth
                name="pickupAddress.mobile"
                label="Mobile"
                value={formik.values.pickupAddress?.mobile}
                onChange={formik.handleChange}
                error={formik.touched.pickupAddress?.mobile&& Boolean(formik.errors.pickupAddress?.mobile)}
                helperText={formik.touched.pickupAddress?.mobile && formik.errors.pickupAddress?.mobile}
                />
            </Grid2>
            <Grid2 size={{xs:6}}>
                <TextField
                fullWidth
                name="pickupAddress.postalCode"
                label="Postal Code"
                value={formik.values.pickupAddress?.postalCode}
                onChange={formik.handleChange}
                error={formik.touched.pickupAddress?.postalCode&& Boolean(formik.errors.pickupAddress?.postalCode)}
                helperText={formik.touched.pickupAddress?.postalCode && formik.errors.pickupAddress?.postalCode}
                />
            </Grid2>
            <Grid2 size={{xs:6}}>
                <TextField
                fullWidth
                name="pickupAddress.city"
                label="City"
                value={formik.values.pickupAddress?.city}
                onChange={formik.handleChange}
                error={formik.touched.pickupAddress?.city&& Boolean(formik.errors.pickupAddress?.city)}
                helperText={formik.touched.pickupAddress?.city && formik.errors.pickupAddress?.city}
                />
            </Grid2>
            <Grid2 size={{xs:6}}>
                <TextField
                fullWidth
                name="pickupAddress.region"
                label="Region"
                value={formik.values.pickupAddress?.region}
                onChange={formik.handleChange}
                error={formik.touched.pickupAddress?.region&& Boolean(formik.errors.pickupAddress?.region)}
                helperText={formik.touched.pickupAddress?.region && formik.errors.pickupAddress?.region}
                />
            </Grid2>
            <Grid2 size={{xs:12}}>
                <TextField
                fullWidth
                name="pickupAddress.country"
                label="Country"
                value={formik.values.pickupAddress?.country}
                onChange={formik.handleChange}
                error={formik.touched.pickupAddress?.country&& Boolean(formik.errors.pickupAddress?.country)}
                helperText={formik.touched.pickupAddress?.country && formik.errors.pickupAddress?.country}
                />
            </Grid2>
        
        </Grid2>
    </>
</Box>
  )
}
